import React, { MutableRefObject } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import { AdditionalInfo } from '../rolecard/agentview/AdditionalInfo';

type TExtraInfoCard = {
    updateField: (field: string, value: string) => void;
    className?: string;
    freelancers_information: string;
    admin_information: string;
    nature_of_business: string;
    required_qualifications: string;
    safety_risks: string;
    available_facilities: string;
    expenses_payable: string;
    title: string;
    default_nature_of_business: string;
    default_required_qualifications: string;
    default_safety_risks: string;
    default_available_facilities: string;
    default_expenses_payable: string;
    freelancersInformationRef?: MutableRefObject<string>;
    natureRef?: MutableRefObject<string>;
    qualificationsRef?: MutableRefObject<string>;
    risksRef?: MutableRefObject<string>;
    facilitiesRef?: MutableRefObject<string>;
    freelancersInformationLabelRef?: MutableRefObject<string>;
    payableRef?: MutableRefObject<string>;
    titleRef?: MutableRefObject<string>;
    natureLabelRef?: MutableRefObject<string>;
    qualificationsLabelRef?: MutableRefObject<string>;
    risksLabelRef?: MutableRefObject<string>;
    facilitiesLabelRef?: MutableRefObject<string>;
    payableLabelRef?: MutableRefObject<string>;
    titleLabelRef?: MutableRefObject<string>;
    isClient: boolean;
    qualificationsChanged?: boolean;
    risksChanged?: boolean;
    facilitiesChanged?: boolean;
    payableChanged?: boolean;
    setQualificationsChanged?: (changed: boolean) => void;
    setRisksChanged?: (changed: boolean) => void;
    setFacilitiesChanged?: (changed: boolean) => void;
    setPayableChanged?: (changed: boolean) => void;
};

export function ExtraInfoCard({
    updateField,
    className,
    freelancers_information,
    admin_information,
    nature_of_business,
    required_qualifications,
    safety_risks,
    available_facilities,
    expenses_payable,
    title,
    default_nature_of_business,
    default_required_qualifications,
    default_safety_risks,
    default_available_facilities,
    default_expenses_payable,
    freelancersInformationRef,
    natureRef,
    qualificationsRef,
    risksRef,
    facilitiesRef,
    payableRef,
    titleRef,
    freelancersInformationLabelRef,
    natureLabelRef,
    qualificationsLabelRef,
    risksLabelRef,
    facilitiesLabelRef,
    payableLabelRef,
    titleLabelRef,
    isClient,
    qualificationsChanged,
    risksChanged,
    facilitiesChanged,
    payableChanged,
    setQualificationsChanged,
    setRisksChanged,
    setFacilitiesChanged,
    setPayableChanged,
}: TExtraInfoCard) {
    const dispatch = useDispatch();

    return (
        <div className={classNames('card card-extrainfo', className)}>
            <div className="card-content">
                <p className="card-title">Extra Information</p>
                <AdditionalInfo
                    updateField={(field: string, data: string) => dispatch(updateField(field, data))}
                    freelancers_information={freelancers_information}
                    admin_information={admin_information}
                    nature_of_business={nature_of_business}
                    required_qualifications={required_qualifications}
                    safety_risks={safety_risks}
                    available_facilities={available_facilities}
                    expenses_payable={expenses_payable}
                    title={title}
                    default_nature_of_business={default_nature_of_business}
                    default_required_qualifications={default_required_qualifications}
                    default_safety_risks={default_safety_risks}
                    default_available_facilities={default_available_facilities}
                    default_expenses_payable={default_expenses_payable}
                    freelancersInformationRef={freelancersInformationRef}
                    natureRef={natureRef}
                    qualificationsRef={qualificationsRef}
                    risksRef={risksRef}
                    facilitiesRef={facilitiesRef}
                    payableRef={payableRef}
                    titleRef={titleRef}
                    freelancersInformationLabelRef={freelancersInformationLabelRef}
                    natureLabelRef={natureLabelRef}
                    qualificationsLabelRef={qualificationsLabelRef}
                    risksLabelRef={risksLabelRef}
                    facilitiesLabelRef={facilitiesLabelRef}
                    payableLabelRef={payableLabelRef}
                    titleLabelRef={titleLabelRef}
                    isClient={isClient}
                    qualificationsChanged={qualificationsChanged}
                    risksChanged={risksChanged}
                    facilitiesChanged={facilitiesChanged}
                    payableChanged={payableChanged}
                    setQualificationsChanged={setQualificationsChanged}
                    setRisksChanged={setRisksChanged}
                    setFacilitiesChanged={setFacilitiesChanged}
                    setPayableChanged={setPayableChanged}
                />
            </div>
        </div>
    );
}
